import { react } from "react";
import { BrowserRouter, Routes, Route } from "react-router";
import { DEFAULT_THEME, createTheme, mergeMantineTheme, MantineProvider } from '@mantine/core';

// core styles are required for all packages
import '@mantine/core/styles.css';
import '../css/site.scss';

// other css files are required only if
// you are using components from the corresponding package
// import '@mantine/dates/styles.css';
// import '@mantine/dropzone/styles.css';
// import '@mantine/code-highlight/styles.css';
// ...

const overrides = createTheme({
	fontFamily: 'Noto Sans, sans-serif',
	fontFamilyMonospace: 'Roboto Mono, monospace',

	'ocean-blue': ['#7AD1DD', '#5FCCDB', '#44CADC', '#2AC9DE', '#1AC2D9', '#11B7CD', '#09ADC3', '#0E99AC', '#128797', '#147885'],
	'bright-pink': ['#F0BBDD', '#ED9BCF', '#EC7CC3', '#ED5DB8', '#F13EAF', '#F71FA7', '#FF00A1', '#E00890', '#C50E82', '#AD1374'],
});

const theme = mergeMantineTheme(DEFAULT_THEME, overrides);

import { StationsPage } from "./pages/stations";
import { FoxFiascoPage } from "./pages/foxfiasco";
import { RecordingPage } from "./pages/recording";

export function App() {
	return (
		<MantineProvider theme={theme} defaultColorScheme="light">
			<BrowserRouter>
				<Routes>
					<Route path="/" element={<h1>HOME</h1>} />
					<Route path="test" element={<h1>TEST</h1>} />
					<Route path="stations" element={<StationsPage />} />
					<Route path="foxfiasco" element={<FoxFiascoPage />} />
					<Route path="recording/:recording_id" element={<RecordingPage />} />
					<Route path="*" element={<h1>404</h1>} />
				</Routes>
			</BrowserRouter>
		</MantineProvider>
	);
}